import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [time, setTime] = useState(() => {
    const saved = sessionStorage.getItem('mp_countdown_end');
    if (saved) {
      const remaining = Math.floor((parseInt(saved) - Date.now()) / 1000);
      return remaining > 0 ? remaining : 0;
    }
    const end = Date.now() + (10 * 60 + 53) * 1000;
    sessionStorage.setItem('mp_countdown_end', end.toString());
    return 10 * 60 + 53;
  });
  useEffect(() => {
    if (time <= 0) return;
    const timer = setInterval(() => {
      setTime(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [time > 0]);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 w-full bg-orange-500 text-white z-50 py-2 px-4 shadow-md text-center font-bold text-sm md:text-base flex items-center justify-center gap-2 animate-pulse" data-id="element-253">
      <Clock className="w-4 h-4 md:w-5 md:h-5" data-id="element-254" />
      <span data-id="element-255">ESTA OFERTA TERMINA PRONTO:</span>
      <span className="bg-slate-900 text-orange-300 px-2 py-0.5 rounded font-mono text-base md:text-lg" data-id="element-256">
        {formatTime(time)}
      </span>
    </div>;
}